import { render } from "./StringColorIcon.vue?vue&type=template&id=4e0ab502"
import script from "./StringColorIcon.vue?vue&type=script&lang=js"
export * from "./StringColorIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__